export const shouldShowVariantPriceRules = ({
    isInBudget,
    shouldDisplayPrices,
    hasRules,
}: {
    isInBudget: boolean;
    shouldDisplayPrices: boolean;
    hasRules: boolean;
}) => !isInBudget && shouldDisplayPrices && hasRules;
